var _circle, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncompleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0045 13.833C26.042 13.833 28.5045 16.2954 28.5045 19.333V20.2497H32.1711V22.083H31.1014L30.4078 30.4091C30.3682 30.8842 29.971 31.2497 29.4943 31.2497H16.5146C16.0378 31.2497 15.6407 30.8842 15.6011 30.4091L14.9066 22.083H13.8378V20.2497H17.5044V19.333C17.5044 16.2954 19.9669 13.833 23.0045 13.833ZM29.2616 22.083H16.7464L17.3578 29.4163H28.6502L29.2616 22.083ZM23.9211 23.9163V27.583H22.0878V23.9163H23.9211ZM20.2544 23.9163V27.583H18.4211V23.9163H20.2544ZM27.5878 23.9163V27.583H25.7545V23.9163H27.5878ZM23.0045 15.6663C21.0408 15.6663 19.4376 17.21 19.3423 19.15L19.3378 19.333V20.2497H26.6711V19.333C26.6711 17.3693 25.1275 15.7662 23.1874 15.6708L23.0045 15.6663Z",
    fill: "#2E3031"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 14.5,
    r: 3.9,
    fill: "#E60A2B",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteIcon);
export default __webpack_public_path__ + "static/media/IncompleteIcon.f024b5b189c97a1b4eef46bcc74118c3.svg";
export { ForwardRef as ReactComponent };